import React from 'react';
import { NavLink } from "react-router-dom";
import { axiosinstance, axiosCatch } from '../../components/axios';
import lscache from 'lscache';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

class ListOfProducts extends React.Component {

	constructor(props, context) {
		super(props, context);

		this.state = {
			error: false,
			products: [
				{
					"title": "Dedicated Servers",
					"description": "A wide selection of dedicated servers ranging from low end bare metal servers that offer a healthy balance between price and computation power to extreme performance clusters and high capacity storage servers.",
					"short": "server",
					"img_url": "dedicated-servers.jpg",
					"img_alt": "Dedicated Servers in Switzerland",
					"url": "/en/dedicated-servers-switzerland",
					"url_offshore": "/en/offshore-dedicated-servers",
					"url_freespeech": "/en/free-speech-dedicated-servers"
				},
				{
					"title": "Confidential Servers",
					"description": "Hardware-enforced confidential computing with AMD SEV encryption. Your data stays encrypted in memory and on disk - only you control the keys. Dedicated-class performance with zero-trust architecture.",
					"short": "confidential",
					"img_url": "dedicated-servers.jpg",
					"img_alt": "Confidential Server in Switzerland",
					"url": "/en/confidential-servers-switzerland",
					"url_offshore": "/en/confidential-servers-switzerland",
					"url_freespeech": "/en/confidential-servers-switzerland"
				}
			]
		}
	}

	componentDidMount() {

		this.load();
	}

	load = () => {

		if (lscache.get('startingFrom') === null) {

			axiosinstance({
				method: 'get',
				url: process.env.REACT_APP_BACKEND_URL + "/products_promo.json",
				params: {},
			})
				.then((response) => {
					if (response.status === 200) {
						if (response.data.result === true) {
							lscache.set('startingFrom', response.data.data, 10);
							this.setState({
								minPrices: response.data.data,
								productsWithPricing: Object.entries(this.state.products).reduce((acc, val) => [
									...acc,
									{ ...val[1], price_from: response.data.data[val[1].short] }
								], [])
							});

						} else {
							this.setState({
								error: true
							});
						}
					} else {
						this.setState({
							error: true
						});
					}
				}).catch((args) => {
					axiosCatch(args, this.props);
				});

		}

		else {
			this.setState({
				minPrices: lscache.get('startingFrom'),
				productsWithPricing: Object.entries(this.state.products).reduce((acc, val) => [
					...acc,
					{ ...val[1], price_from: lscache.get('startingFrom')[val[1].short] }
				], [])
			})
		}

		if (lscache.get('exchangeRates') === null) {

			axiosinstance.get(process.env.REACT_APP_BACKEND_URL + "/variables.json")
				.then(res => {

					if (res.status === 200 && res.data.result === true) {
						this.setState({
							usd: res.data.data.currencies.find(x => x.short_name === 'USD').rate,
							eur: res.data.data.currencies.find(x => x.short_name === 'EUR').rate,
							btc: res.data.data.currencies.find(x => x.short_name === 'BTC').rate
						})
						lscache.set('exchangeRates', res, 3);
					}

					else {
						this.setState({
							error: true
						});
					}

				})
		}
		else {
			this.setState({
				usd: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'USD').rate,
				eur: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'EUR').rate,
				btc: lscache.get('exchangeRates').data.data.currencies.find(x => x.short_name === 'BTC').rate
			})
		}

	};

	render() {

		const page = this.props.page

		let productsMap = !this.state.productsWithPricing ? this.state.products : this.state.productsWithPricing
		const columnClass = productsMap.length === 2 ? 'six columns' : 'four columns';
		const getPriceFrom = (product) => {
			if (product.price_override !== undefined && product.price_override !== null) {
				return product.price_override;
			}
			if (product.short === 'server') {
				return 166.96;
			}
			if (product.short === 'confidential') {
				return 139;
			}
			return product.price_from;
		};
		const getBillingUnit = (product) => product.billing_unit || (product.short === 'cdn_per_gb' ? 'per GB' : 'per month');

		if (page === 'home') {
			return (
				<div className="row index-products-grid">
					{productsMap.map((product, i) =>
						<div className={`${columnClass} index-products-grid-item`} key={i}>
							<div className="panel products">
								<NavLink to={product.url} className="product-title"><h2>{product.title}</h2></NavLink>
								<hr className="black" />
								<p>{product.description}</p>
								<div className="row">
									<div className="twelve columns from margintop">
										{!this.state.productsWithPricing
											? <Skeleton className={'skeletonPreloader'} />
											: (() => {
												const priceFrom = getPriceFrom(product);
												return <React.Fragment><span className="chf"><small>from</small> {priceFrom} CHF</span><span>{(priceFrom * this.state.usd).toFixed(2)} USD / {(priceFrom * this.state.eur).toFixed(2)} EUR</span><br /><span>{getBillingUnit(product)}</span></React.Fragment>
											})()
										}
									</div>
									<NavLink to={product.url} className="button radius large right">View plans</NavLink>
								</div>
							</div>
						</div>
					)}
				</div>
			)
		}

		else {
			return (
				<div className="fullwidth light">
					<div className="row" >
						<div className="twelve columns products-pane" >
							{productsMap.map((product, i) =>
								<div className={columnClass} key={i}>
									<div className="panel pricing products">
										<NavLink to={page === 'offshore' ? product.url_offshore : page === 'freespeech' ? product.url_freespeech : product.url} className="product-title"><h1>{product.title}</h1></NavLink>
										<hr className="black" />
										<p>{product.description}</p>
										<div className="row price">
											<div className="twelve columns from margintop">
												{!this.state.productsWithPricing
													? <Skeleton className={'skeletonPreloader'} />
													: (() => {
														const priceFrom = getPriceFrom(product);
														return <React.Fragment><span className="chf"><small>from</small> {priceFrom} CHF</span><span>{(priceFrom * this.state.usd).toFixed(2)} USD / {(priceFrom * this.state.eur).toFixed(2)} EUR</span><br /><span>{getBillingUnit(product)}</span></React.Fragment>
													})()
												}
											</div>
										</div>
										<NavLink className="button radius large right" to={page === 'offshore' ? product.url_offshore : page === 'freespeech' ? product.url_freespeech : product.url}>View plans</NavLink>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
			)
		}
	}
}

export default ListOfProducts
